import { Component } from '@angular/core';
import { ApplicationFormPreviewCardComponent } from '../irembogov-application-form-preview-card/application-form-preview-card.component';

@Component({
  selector: 'irembogov-application-generic-form-preview-card',
  templateUrl:
    './irembogov-application-generic-form-preview-card.component.html',
})
export class IrembogovApplicationGenericFormPreviewCardComponent extends ApplicationFormPreviewCardComponent {}
